import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';

import {
    Button,
    Icon,
    Modal,
    ModalContainer,
    ModalContainerHeader,
    ModalContainerContent,
    ModalContainerAction,
    Table,
    TableBody,
    TableHeader,
    TableRow,
    TableCell,
    Title,
    Tag,
} from 'yurstrap';

import { removeNotification } from '../../services/Notifications';

const propTypes = {
    NotificationsActions: PropTypes.shape({
        removeNotification: PropTypes.func.isRequired,
    }).isRequired,
    bulkNotifications: PropTypes.arrayOf(PropTypes.object).isRequired,
    bulkName: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    withI18N: PropTypes.bool,
};

const defaultProps = {
    withI18N: false,
};

const colors = {
    errors: 'delete',
    success: 'action',
};

export class NotificationsModal extends Component {

    renderMessage(notification) {
        const { withI18N } = this.props;
        if (!withI18N) return notification.message;
        return (
            <FormattedMessage id={notification.message} />
        );
    }

    renderModalContent() {
        const { bulkNotifications } = this.props;
        if (!bulkNotifications
         || bulkNotifications.length <= 0) {
            return (
                <em>
                    Aucune information
                </em>
            );
        }
        const rows = _.map(bulkNotifications, (notification) => (
            <TableRow key={notification.id}>
                <TableCell>
                    {moment(notification.date).fromNow()}
                </TableCell>
                <TableCell>
                    {this.renderMessage(notification)}
                </TableCell>
                <TableCell>
                    {notification.state === 'success' ? (
                        <Tag color="success">
                            Succès
                        </Tag>
                    ) : false}
                    {notification.state === 'error' ? (
                        <Tag color="error">
                            Échec
                        </Tag>
                    ) : false}
                    {notification.state === 'pending' ? (
                        <Tag color="default">
                            En cours
                        </Tag>
                    ) : false}
                </TableCell>
            </TableRow>
        ));
        return (
            <Table>
                <TableHeader>
                    <TableRow>
                        <TableCell>
                            Date
                        </TableCell>
                        <TableCell>
                            Message
                        </TableCell>
                        <TableCell>
                            Statut
                        </TableCell>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {rows}
                </TableBody>
            </Table>
        );
    }

    renderBulkName() {
        const {
            bulkName,
            withI18N,
        } = this.props;
        if (!withI18N) return bulkName;
        return (
            <FormattedMessage id={bulkName} />
        );
    }

    render() {
        const { bulkNotifications, onClose } = this.props;
        const confirmButtonColor = _.reduce(bulkNotifications, (currentState, notification) => {
            if (notification.state === 'error') {
                return colors.error;
            }
            return currentState;
        }, colors.success);
        return (
            <Modal onClose={onClose}>
                <ModalContainer>
                    <ModalContainerHeader>
                        <Title>
                            {this.renderBulkName()}
                        </Title>
                        <Button
                            color="tertiary"
                            square
                            onClick={onClose}
                        >
                            <Icon collection="yp" icon="close" />
                        </Button>
                    </ModalContainerHeader>
                    <ModalContainerContent>
                        {this.renderModalContent()}
                    </ModalContainerContent>
                    <ModalContainerAction>
                        <Button color={confirmButtonColor} onClick={onClose}>
                            Fermer
                        </Button>
                    </ModalContainerAction>
                </ModalContainer>
            </Modal>
        );
    }

}

NotificationsModal.propTypes = propTypes;

NotificationsModal.defaultProps = defaultProps;

function mapStateToProps(state, ownProps) {
    return {
        bulkNotifications: _.filter(state.Notifications.notifications, {
            bulkName: ownProps.bulkName,
        }),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        NotificationsActions: bindActionCreators({
            removeNotification,
        }, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(NotificationsModal);
